namespace GeniuzPOS.Inventory {
    export interface IcStockAdjustInForm {
        SysDocNo: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        RefDocNo1: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        StkAdjCode: Serenity.LookupEditor;
        WhsId: Serenity.LookupEditor;
        AdjFg: Serenity.EnumEditor;
        StockFrom: Serenity.StringEditor;
        PostFg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        Remark: Serenity.TextAreaEditor;
        AdjustInDtList: IcStockAdjustInDtEditor;
    }

    export class IcStockAdjustInForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockAdjustIn';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockAdjustInForm.init)  {
                IcStockAdjustInForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.EnumEditor;
                var w4 = s.TextAreaEditor;
                var w5 = IcStockAdjustInDtEditor;

                Q.initFormType(IcStockAdjustInForm, [
                    'SysDocNo', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'RefDocNo1', w0,
                    'RefDocNo2', w0,
                    'StkAdjCode', w2,
                    'WhsId', w2,
                    'AdjFg', w3,
                    'StockFrom', w0,
                    'PostFg', w3,
                    'CancelFg', w3,
                    'Remark', w4,
                    'AdjustInDtList', w5
                ]);
            }
        }
    }
}
